export default "__VITE_ASSET__DxANji6u__"